export default "__VITE_ASSET__fNrSOuB3__"